import React from "react";
import { withRouter } from "react-router-dom";
import { decodedToken } from "../../constants/constants";
import EmployeeHome from "./employeeHome";
import TenantHome from "./tenantHome";

class Home extends React.Component {
  render() {
    return decodedToken.value.activeKey === "employee" ? (
      <EmployeeHome />
    ) : (
      <TenantHome />
    );
  }
}

export default withRouter(Home);
